export default "__VITE_ASSET__BMAYwBV6__"